import React from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import './particle.css';
const Particle = () => {
  const particlesInit = async (engine) => {
    // Initiate tsParticles instance (engine) here, adding custom shapes or presets
    await loadFull(engine);
  };

  const particlesLoaded = async (container) => {
    console.log(container);
  };

  return (
    <div className="particle-container">
    <Particles
      id="particles-js"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        particles: {
          number: {
            value: 100,
            density: { enable: true, value_area: 2000 },
          },
          color: { value: "#00ffff" },
          shape: {
            type: "circle",
            stroke: { width: 0, color: "#000000" },
            polygon: { nb_sides: 10 },
            image: { src: "img/github.svg", width: 500, height: 100 },
          },
          opacity: {
            value: 0.2,
            random: true,
            anim: { enable: false, speed: 1, opacity_min: 0.1, sync: false },
          },
          size: {
            value: 40,
            random: true,
            anim: { enable: false, speed: 40, size_min: 0.1, sync: false },
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: "#ffffff",
            opacity: 0.3,
            width: 1,
          },
          move: {
            enable: true,
            speed: 6,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: { enable: false, rotateX: 600, rotateY: 1200 },
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: { enable: true, mode: "repulse" },
            onclick: { enable: true, mode: "push" },
            resize: true,
          },
          modes: {
            grab: { distance: 400, line_linked: { opacity: 1 } },
            bubble: { distance: 400, size: 40, duration: 2, opacity: 8, speed: 3 },
            repulse: { distance: 200, duration: 0.4 },
            push: { particles_nb: 4 },
            remove: { particles_nb: 2 },
          },
        },
        retina_detect: true,

      }}

    />
    </div>
  );
};

export default Particle;
